import { render } from "./AddPromotion.vue?vue&type=template&id=611d2531&ts=true"
import script from "./AddPromotion.vue?vue&type=script&lang=ts"
export * from "./AddPromotion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__